import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerResourceAdd,
  BackendMutationCustomerResourceFileAddArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation CustomerResourcesFileAdd(
    $customerId: ID!
    $workspaceId: ID!
    $resourceFileType: CustomerResourceFileEnum!
    $name: String!
    $tags: [String!]!
    $fileInfo: CustomerResourcesFileAddInfo!
  ) {
    customerResourceFileAdd(
      customerId: $customerId
      workspaceId: $workspaceId
      resourceFileType: $resourceFileType
      name: $name
      tags: $tags
      fileInfo: $fileInfo
    ) {
      id
      type
      fileUploadInfo {
        fileUploadPresignedUrl
        fileUploadPresignedUrlExpiresAt
      }
    }
  }
`;

type Variables = BackendMutationCustomerResourceFileAddArgs;

export const customerResourceFileAdd = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });

  const data = getSingleProp<BackendCustomerResourceAdd>(result.data);
  if (!data) {
    return null;
  }

  return {
    id: data.id,
    uploadUrl: data.fileUploadInfo?.fileUploadPresignedUrl,
  };
};
